import React from "react";
import PropTypes from "prop-types";
import ActionFilter from "../ActionFilter";
// import ConfirmationDialog from '../../../../components/ConfirmationDialog';

function DebitorTaskMenu({
  forwardedRef,
  className = "",
  items = [],
  filterDebitors,
  debitorTaskType,
}) {
  return (
    <div className={className}>
      <ActionFilter
        type="Debitor"
        taskType={debitorTaskType}
        setTaskType={filterDebitors}
        itemsToCount={items}
        className="display-inline-block pad-big-rht-"
      />
      {/* <ConfirmationDialog ref={ref => this.taskDialog = ref}/> */}
    </div>
  );
}

DebitorTaskMenu.propTypes = {
  className: PropTypes.string,
  debitorTaskType: PropTypes.string,
  filterDebitors: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};

export default React.forwardRef((props, ref) => (
  <DebitorTaskMenu {...props} forwardedRef={ref} />
));
